var map = {
	"./soils_example_1_1.png": 1279,
	"./soils_example_1_2.png": 1280,
	"./soils_example_1_3.png": 1281,
	"./soils_example_2_1.png": 1282,
	"./soils_example_2_2.png": 1283,
	"./soils_example_2_3.png": 1284,
	"./soils_manuals_1.png": 1285,
	"./soils_overview_1.png": 1286,
	"./soils_overview_2.png": 1287,
	"./soils_reports_1.png": 1288,
	"./soils_reports_2.png": 1289,
	"./soils_reports_3.png": 1290,
	"./soils_reports_4.png": 1291,
	"./soils_reports_5.png": 1292,
	"./soils_reports_6.png": 1293
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images ^\.\/.*$
// module id = 272
// module chunks = 0